export enum EmailErrorCode {
    MainEmailInvalid = 'MAIN_EMAIL_INVALID',
    MainEmailNotUnique = 'MAIN_EMAIL_NOT_UNIQUE',
    EmailInvalid = 'EMAIL_INVALID',
}

export const EmailErrorCodeMessageId: Record<EmailErrorCode, string> = {
    [EmailErrorCode.EmailInvalid]: 'app.error.email',
    [EmailErrorCode.MainEmailInvalid]: 'app.error.email',
    [EmailErrorCode.MainEmailNotUnique]: 'app.error.uniqueEmail',
};
